<template>
  <div>
    <label v-if="label" class="form-select-label" :for="id">{{ label }}:</label>
    <div class="relative w-full">
      <select :id="id" ref="input" v-model="selected" v-bind="$attrs" class="form-select" :class="{ error: dataError }">
        <slot/>
      </select>
    </div>
    <div v-if="dataError" class="text-red-500 text-sm mt-2">{{ dataError }}</div>
  </div>
</template>

<script>
  export default {
    inheritAttrs: false,
    props: {
      id: {
        type: String,
        default() {
          return `select-input-${this._uid}`
        },
      },
      value: [String, Number, Boolean],
      label: String,
      dataError: String
    },
    data() {
      return {
        selected: this.value,
      }
    },
    watch: {
      selected(selected) {
        this.$emit('input', selected)
      },
      value(selectedValue) {
        this.selected = selectedValue;
      }
    },
    methods: {
      focus() {
        this.$refs.input.focus()
      },
      select() {
        this.$refs.input.select()
      },
    },
  }
</script>
